/**
 * @file Ad/constants.js
 * @copyright 2020 CBC/Radio-Canada. All rights reserved.
 */

export const NATIVE_AD_TYPE = "native-ad";
export const LOADMORE_AD_TYPE = "load-more";
